import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Link } from 'gatsby';
import PaginationLinks from '../../shared/pagination/links/PaginationLinks';

const LinkList = ({ title, tabs, activeTab, links, pagination, t }) => {
  return (
    <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-10 max-w-6xl">
      <div className="flex flex-col flex-1 gap-10 md:gap-3 py-5 items-center">
        <Typography as={'h1'} fontVariant={'h4'} className={'mb-10'}>
          {title}
        </Typography>
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-5 w-full">
          {tabs.map((tab) => {
            return (
              <LinkButton
                variant={'transparent'}
                className={`border border-customGray-300 text-clamp-md ${
                  activeTab === tab.title && 'bg-primary-700 text-white'
                }`}
                key={tab.title}
                href={tab.href}
                label={tab.title}
              />
            );
          })}
        </div>
        {links && (
          <>
            <ul className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-10 gap-y-2 my-5 max-sm:w-full w-fit">
              {links.map((link) => {
                return (
                  <li key={link.title}>
                    <Link
                      className={
                        'text-clamp-md underline text-primary-500 global-hover'
                      }
                      to={link.href}
                    >
                      {link.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <PaginationLinks
              totalPages={pagination?.pages?.length}
              currentPage={pagination?.currentPage}
              pages={pagination?.pages}
              t={t}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default LinkList;
